const getRandomItem = (arr: string[]) =>
    arr[Math.floor(Math.random() * arr.length)];

export default getRandomItem;
